import { formatAppDateTime } from "./app-time.js";

// Use the field's own time; a polling or page-load time must not make old data look fresh.
export function updateConditionsTime(element, validTime) {
  if (!element) return;
  const label = validTime && formatAppDateTime(validTime, { timeOptions: { timeZoneName: "short" } });
  element.replaceChildren();
  if (!label) {
    element.textContent = "Conditions time unavailable";
    return;
  }
  const time = element.ownerDocument.createElement("time");
  time.dateTime = validTime;
  time.textContent = label;
  const timestamp = element.ownerDocument.createElement("span");
  timestamp.append("Conditions as of ", time);
  element.append(timestamp);
}
